import { render, staticRenderFns } from "./logisticsDelivery.vue?vue&type=template&id=472db613&scoped=true&"
import script from "./logisticsDelivery.vue?vue&type=script&lang=js&"
export * from "./logisticsDelivery.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDelivery.vue?vue&type=style&index=0&id=472db613&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472db613",
  null
  
)

export default component.exports